export function getStatusClass(subscription) {
  const status = normalizeStatusValue(subscription && subscription.status);

  switch (status) {
    case 1:
      return "text-orange-600";
    case 4:
      return "text-red-600";
    case 3:
      return "text-blue-600";
    case 2:
      return "text-green-700";
    default:
      return "text-orange-600";
  }
}

export function getStatusLabel(status) {
  const normalized = normalizeStatusValue(status);

  switch (normalized) {
    case 1:
      return "In Trial";
    case 4:
      return "Cancelled";
    case 3:
      return "Non renewing";
    case 2:
      return "Active";
    default:
      return "N/A";
  }
}

export function getStatusClassWrapper(entity) {
  const status = normalizeStatusValue(
    entity && (entity.status || (entity.subscription && entity.subscription.status))
  );

  switch (status) {
    case 1:
      return "bg-orange-100";
    case 4:
      return "bg-red-100";
    case 3:
      return "bg-blue-100";
    case 2:
      return "bg-green-100";
    default:
      return "bg-orange-100";
  }
}

function normalizeStatusValue(value) {
  if (value === undefined || value === null) {
    return null;
  }

  if (typeof value === "boolean") {
    return value ? 2 : 4;
  }

  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();

    if (normalized === "") {
      return null;
    }

    const statusMap = {
      active: 2,
      "in trial": 1,
      trial: 1,
      "non renewing": 3,
      "non-renewing": 3,
      nonrenewing: 3,
      "not renewing": 3,
      cancelled: 4,
      canceled: 4,
      inactive: 4,
      deactivated: 4,
      disabled: 4
    };

    if (statusMap[normalized] !== undefined) {
      return statusMap[normalized];
    }

    const numericFromString = Number(normalized);
    return Number.isNaN(numericFromString) ? null : numericFromString;
  }

  const numeric = Number(value);
  return Number.isNaN(numeric) ? null : numeric;
}
